import React from 'react';
import { array, func, object, oneOfType, shape, string, bool } from 'prop-types';
import { SLIDEOUTS } from 'ps-components/Slideout/Slideouts';

SmartOption.propTypes = {
  action: shape({
    action: string,
    category: string,
    data: oneOfType([array, object]),
    query: string,
    target: string
  }),
  subsite: string,
  showSlideout: func
};

export default function SmartOption(props) {
  if (!props.action) return null;

  const { action, category, data, query, target, name } = props.action;
  const baseUrl = `/view/o/${props.subsite}/mp`;

  function getDocsOption() {
    const url = `${baseUrl}/${query}`;

    return (
      <div className="smart-search__docs" onClick={() => window.open('https://connect.payscale.com/', '_blank')}>
        {target === 'User Guide' ? `Open User Guide` : `Open documentation for ${target}`}
      </div>
    );
  }

  function getNavigateOption() {
    let options = null;

    if (query) {
      // Default navigation
      // TODO add deep intergration with user guide section and navigation name
      const url = `${baseUrl}/${query}`;

      options = [
        <div className="smart-search__navigation" onClick={() => (document.location.href = url)}>
          {`Navigate to ${target}`}
        </div>
      ];
    }

    return options;
  }

  function getJobsOption() {
    let options = null;

    if (target === 'create') {
      // Create a new job, go to ad-hoc pricing
      const url = `${baseUrl}/market-analysis/jobs/adhoc/survey-library`;

      options = [
        <div className="smart-search__navigation" onClick={() => (document.location.href = url)}>
          {'Create a new Ad Hoc Pricing'}
        </div>
      ];
    } else if (target === 'recent-jobs' && data) {
      // Find recently modified jobs by the current user
      options = data.map(job => {
        const { org_job_id, org_job_title, org_job_code, org_job_code_key, slot_p, currency } = job;
        const url = `${baseUrl}/market-analysis/jobs/${org_job_id}/pricing`;

        return (
          <div className="smart-search__navigation job" onClick={() => (document.location.href = url)}>
            <div className="title">{org_job_title}</div>
            <div className="info">{`${org_job_code} ${org_job_code_key}, ${currency}, ${slot_p}`}</div>
          </div>
        );
      });
    } else {
      if (query) {
        // Search jobs with a given filter preselected
        let upperQuery = query;

        if (target !== 'job_price_status') {
          upperQuery = toTitleCase(query);
        }
        if (target === 'currency') {
          upperQuery = query.toUpperCase();
        }
        let queryURL = `${target}%5B0%5D=${upperQuery}`;

        if (target === 'org_job_title' || target === 'org_job_code' || target === 'search') {
          queryURL = `q=${query}`;
        }
        const url = `${baseUrl}/market-analysis/market-pricing?${queryURL}`;

        options = [
          <div className="smart-search__navigation" onClick={() => (document.location.href = url)}>
            {`Find Jobs with ${name}: ${upperQuery}`}
          </div>
        ];
      } else {
        const url = `${baseUrl}/market-analysis/market-pricing`;

        options = [
          <div className="smart-search__navigation" onClick={() => (document.location.href = url)}>
            {`Navigate to Market Pricing`}
          </div>
        ];
      }
    }

    return options;
  }

  function getSupportOption() {
    // Open support slideout
    return [
      <div className="smart-search__navigation" onClick={() => props.showSlideout(SLIDEOUTS.CONTACT_SUPPORT_SLIDEOUT)}>
        {'Contact Support'}
      </div>
    ];
  }

  function getHiddenOption() {
    return [<div className="smart-search__hidden">{target}</div>];
  }

  function getSmartOption() {
    if (action === 'docs') {
      return getDocsOption();
    } else if (action === 'navigate') {
      return getNavigateOption();
    } else if (action === 'support') {
      return getSupportOption();
    } else if (action === 'jobs') {
      return getJobsOption();
    } else if (action === 'hidden') {
      return getHiddenOption();
    }

    return null;
  }

  return (
    <div className="smart-search__option" key={`smart-option-${action}-${category}-${query}`}>
      {getSmartOption() || <div className="smart-search__error">{'No suggestions found'}</div>}
    </div>
  );
}

function toTitleCase(value) {
  return value
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}
